import { call, put, takeEvery } from 'redux-saga/effects';
import { FETCH_HOME_FEED } from "../actionTypes";
import { apiCall } from "../../services";
import { history } from "../../utils/history";
import {  setLoader, removeLoader, fetchHomeFeedSuccess } from "../actions"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function* fetchHomeFeed(actions) {
	yield put(setLoader());

	const fetchHomeFeedAction = yield apiCall({ body: {...actions.data},url:'get_customer_info'});
	
	if (fetchHomeFeedAction) {
		yield put(removeLoader());
		if(fetchHomeFeedAction.data.success){
			yield put(fetchHomeFeedSuccess(fetchHomeFeedAction.data));
		}else {
			if(fetchHomeFeedAction.data.msg === "Token Unauthorized"){
				window.localStorage.removeItem('access_token')
				history.push('/login')
			}else{
				const options = {
					autoClose: 2500,
					hideProgressBar: true,
					position: toast.POSITION.BOTTOM_CENTER,
					closeButton: false,
					draggable: false,
					pauseOnFocusLoss: false,
					closeOnClick: false
				};
				toast.error(fetchHomeFeedAction.data.msg, options)
			}
		} 
	} 
}
export default function* root() {
  	yield takeEvery(FETCH_HOME_FEED, fetchHomeFeed);
}